/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { SafetyActivity, CollaboratorEvaluation, ILULevel } from '../types.ts';

export const INITIAL_SAFETY_ACTIVITIES: SafetyActivity[] = [];

export const INITIAL_COLLABORATOR_EVALUATIONS: CollaboratorEvaluation[] = [];

export const ILU_LEVEL_DEFINITIONS: Record<ILULevel, {
  label: string;
  badgeText: string;
  shortDesc: string;
  fullDesc: string;
  colorBg: string;
  colorBorder: string;
  colorText: string;
  hexCode: string;
  iconSymbol: string;
}> = {
  I: {
    label: 'Nivel I - Inducción / En Formación',
    badgeText: 'NIVEL I (INDUCCIÓN)',
    shortDesc: 'Conoce la teoría / Requiere acompañamiento total',
    fullDesc: 'El colaborador ha recibido la capacitación teórica básica pero no está autorizado para ejecutar la actividad de manera independiente. Requiere supervisión constante de un instructor o mentor.',
    colorBg: 'bg-amber-500/20',
    colorBorder: 'border-amber-500/50',
    colorText: 'text-amber-400',
    hexCode: '#f59e0b',
    iconSymbol: '🟠'
  },
  L: {
    label: 'Nivel L - En Desarrollo / Supervisado',
    badgeText: 'NIVEL L (EN DESARROLLO)',
    shortDesc: 'Ejecuta bajo supervisión periódica / En práctica',
    fullDesc: 'El colaborador comprende y realiza los pasos de la actividad pero aún requiere validación y supervisión periódica para asegurar el cumplimiento estricto de las normas de seguridad.',
    colorBg: 'bg-sky-500/20',
    colorBorder: 'border-sky-500/50',
    colorText: 'text-sky-400',
    hexCode: '#0ea5e9',
    iconSymbol: '🔵'
  },
  U: {
    label: 'Nivel U - Autónomo / Capacitado',
    badgeText: 'NIVEL U (AUTÓNOMO)',
    shortDesc: 'Domina la tarea con seguridad / 100% Capacitado',
    fullDesc: 'El colaborador domina completamente el estándar de seguridad y la técnica operativa. Puede ejecutar la actividad de forma totalmente independiente sin riesgo y con apego a normas.',
    colorBg: 'bg-emerald-500/20',
    colorBorder: 'border-emerald-500/50',
    colorText: 'text-emerald-400',
    hexCode: '#10b981',
    iconSymbol: '🟢'
  },
  O: {
    label: 'Nivel O - Instructor / Auditor (Master)',
    badgeText: 'NIVEL O (INSTRUCTOR)',
    shortDesc: 'Capacita, audita y optimiza el procedimiento',
    fullDesc: 'El colaborador es un referente técnico y de seguridad. Tiene facultades para capacitar, evaluar competencias y auditar el procedimiento en planta.',
    colorBg: 'bg-purple-500/20',
    colorBorder: 'border-purple-500/50',
    colorText: 'text-purple-400',
    hexCode: '#a855f7',
    iconSymbol: '🟣'
  }
};
